module.exports = __webpack_public_path__ + "static/media/11.ad6ee764.jpg";